import React, { useState } from "react";

const useDataState = () => {
  // Filter Options Data
  const [filterOptions, setFilterOption] = useState({});
  const [formData, setFormData] = useState({});

  // return for state
  return {
    filterOptions,
    setFilterOption,
    formData,
    setFormData,
  };
};

export default useDataState;
